class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.generateRecommendations();
    this.ajaxifyItems();
  }

  generateRecommendations() {
    const cartItems = document
      .getElementById("AjaxCartForm")
      .querySelectorAll("[data-js-cart-item]");
    if (cartItems.length > 0) {
      fetch(
        `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`
      )
        .then((response) => response.text())
        .then((text) => {
          const innerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("[data-js-cart-recommendations-performed]");
          if (
            innerHTML &&
            innerHTML.querySelectorAll("[data-js-product-item]").length > 0
          ) {
            this.innerHTML = innerHTML.innerHTML;
            this.ajaxifyItems();
          }
        });
    }
  }

  ajaxifyItems() {
    const quickViewButtons = this.querySelectorAll(".open-quick-view");
    quickViewButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const handle = target.getAttribute("data-handle");
        const quickViewElement = document.querySelector("quick-view");
        if (quickViewElement) {
          quickViewElement.handle = handle;
          quickViewElement.sectionId = target.dataset.sectionId || "quick-view";
          quickViewElement.propertyType = target.dataset.type || "";
          quickViewElement.generateQuickView();
          this.openSidebar();
        } else {
          console.error("Quick view element not found");
        }
      });
    });
  }

  openSidebar() {
    const sidebar = document.getElementById("site-quick-view-sidebar");
    if (sidebar) {
      sidebar.show();
    }
  }
}
customElements.define("cart-recommendations", CartRecommendations);
